import { useRouter } from "next/router";

export const useShortLocale = (): string => {
  const { locale } = useRouter();
  const [shortLocale] = locale ? locale.split("-") : ["he"];
  return shortLocale;
};
